import { render, staticRenderFns } from "./CompetencePicker.vue?vue&type=template&id=8c933114"
import script from "./CompetencePicker.vue?vue&type=script&lang=js"
export * from "./CompetencePicker.vue?vue&type=script&lang=js"
import style0 from "./CompetencePicker.vue?vue&type=style&index=0&id=8c933114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports